<script setup lang="ts">
import './assets/style.scss'
import { VInputChips, VModal } from '@/shared/ui'
import { useReportSubscriptionModel } from './../model/model'
import { useHelpers } from '@/shared/lib'
import { useAuth } from '@/entities/Auth'
import { watch } from 'vue'

defineProps({
  title: {
    type: String,
    required: true,
  },
})

const model = useReportSubscriptionModel()
const { numberList, weekdayList } = useHelpers()
const emits = defineEmits(['submit'])
const auth = useAuth()

/** Добавляем email авторизованного пользователя */
watch(
  () => model.openForm,
  () => {
    if (model.openForm && auth.user?.email) {
      model.data.receivers.push(auth.user.email)
    }
  },
)

/**
 * Обработчик отправки формы
 */
const submitHandler = () => {
  emits('submit', model.data)

  model.openForm = false
}
</script>

<template>
  <VModal v-model="model.openForm" :max-width="500" :title>
    <VForm @submit.prevent="submitHandler">
      <VInputChips
        v-model="model.data.receivers"
        :label="$t('itf.subscribe_recipients')"
        :rule="model.rules.recipients"
      />

      <p class="mt-4 mb-1">{{ $t('itf.periodicity') }}</p>

      <VRadioGroup v-model="model.data.type" inline hide-details>
        <VRadio :label="$t('itf.daily')" :value="1" />
        <VRadio :label="$t('itf.weekly')" :value="2" />
        <VRadio :label="$t('itf.monthly')" :value="3" />
      </VRadioGroup>

      <VSelect
        class="mt-4"
        :label="$t('itf.report_send_day')"
        :items="weekdayList()"
        hide-details
        v-if="model.data.type == 2"
        v-model="model.data.params.period"
      />

      <VSelect
        class="mt-4"
        :label="$t('itf.report_send_day')"
        :items="numberList(27)"
        hide-details
        v-if="model.data.type == 3"
        v-model="model.data.params.period"
      />

      <VTextField
        type="time"
        class="mt-4"
        :label="$t('itf.report_time')"
        v-model="model.data.params.time"
      />

      <div class="form__btn_right">
        <VBtn type="submit" :disabled="!model.data.receivers.length">
          {{ $t('itf.save') }}
        </VBtn>

        <VBtn color="default" @click="model.openForm = false">
          {{ $t('itf.close') }}
        </VBtn>
      </div>
    </VForm>
  </VModal>
</template>
